import React, { useState } from "react";
import styles from "./styles.css";
import { validateEmail, validatePassword } from "../../utils/Formatter";
import Check from "../../icons/Check";
import Back from "../../icons/Back";
import Button from "../Button";
import { useNavigate } from "react-router-dom";

const Header = ({ withBackButton = true, renderRight }) => {
    const navigate = useNavigate()
    return (
        <div
            className={"header"}
        >
            {withBackButton && <Button className={"back"} onClick={() => navigate(-1)}>
                <Back />
            </Button>}
            <span style={{ height: 54 }} />
            <img src={require('../../images/logo_white.png')} className="logo" />
            <div className="right-container">
                {renderRight && renderRight()}
            </div>
        </div>
    );
};

export default Header;
